var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeasonManifestationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#F27E30;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#F27E30;stroke-width:2;}\n\t.st3{fill:#F27E30;stroke:#F27E30;stroke-width:0.1;stroke-opacity:0.8;}\n")), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,38h24",
    style: {
      strokeOpacity: 0.8,
      stroke: "rgb(140, 39, 30)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M 13.1 29.9 C 13.1 29.5 13.4 29.1 13.9 29.1 L 36 29.1 L 36 16.1 C 36 15.7 36.3 15.3 36.8 15.3 C 37.2 15.3 37.6 15.6 37.6 16.1 L 37.6 29 C 37.6 29.8 36.9 30.5 36.1 30.5 L 13.9 30.5 C 13.4 30.6 13.1 30.3 13.1 29.9 Z M 11.6 13.1 L 32.9 13.1 C 33.3 13.1 33.7 13.4 33.7 13.9 L 33.7 26 C 33.7 26.4 33.4 26.8 32.9 26.8 L 11.6 26.8 C 11.2 26.8 10.8 26.5 10.8 26 L 10.8 13.9 C 10.8 13.4 11.2 13.1 11.6 13.1 Z M 3.1 10 L 3.1 33 C 3.1 33.6 3.5 34 4.1 34 L 44.1 34 C 44.7 34 45.1 33.6 45.1 33 L 45.1 10 C 45.1 9.4 44.7 9 44.1 9 L 4.1 9 C 3.6 9 3.1 9.4 3.1 10 Z",
    style: {
      strokeOpacity: 1,
      strokeWidth: 0,
      stroke: "rgb(140, 39, 30)",
      fill: "rgb(140, 39, 30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 4.102 9.011 L 44.102 9.011 C 44.702 9.011 45.102 9.411 45.102 10.011 L 45.102 33.011 C 45.102 33.611 44.702 34.011 44.102 34.011 L 4.102 34.011 C 3.502 34.011 3.102 33.611 3.102 33.011 L 3.102 10.011 C 3.102 9.411 3.602 9.011 4.102 9.011 Z",
    style: {
      stroke: "rgb(140, 39, 30)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeasonManifestationRed);
export default __webpack_public_path__ + "static/media/season_manifestation_red.af2693c136a23581775b15f7c5c19411.svg";
export { ForwardRef as ReactComponent };